import CrudAPI from '@/api/resources/crud'
import store from '@/store'

const servicesAPI = {
  // specific services api
  resource: 'services',

  loadService (id) {
    return new Promise((resolve, reject) => {
      let service = CrudAPI.dfsResourceShow(this.resource, id)

      service.then(result => {
        resolve(result)
      }, error => {
        reject(error)
      })
    })
  },

  loadAllServices () {
    return new Promise((resolve, reject) => {
      let services = CrudAPI.dfsResourceIndex(this.resource)

      services.then(result => {
        result.forEach((item, i) => {
          item.text = item.name
          item.value = item.id
        })

        resolve(result)
      }, error => {
        reject(error)
      })
    })
  },

  loadServices () {
    return new Promise((resolve, reject) => {
      let services = CrudAPI.dfsResourceIndex(this.resource)

      services.then(result => {
        result.forEach((item, i) => {
          item.text = item.name
          item.value = item.id
        })

        resolve(result)
      }, error => {
        reject(error)
      })
    })
  },

  getReportQuantitiesSold (from, to) {
    return new Promise((resolve, reject) => {
      let services = CrudAPI.dfsResourceIndex(this.resource + '/statistics/quantitiesSold/from/' + from + '/to/' + to)

      services.then(result => {
        resolve(result)
      }, error => {
        reject(error)
      })
    })
  },

  loadProducts () {
    return new Promise((resolve, reject) => {
      let products = CrudAPI.dfsResourceIndex('products')

      products.then(result => {
        result.forEach((item, i) => {
          item.text = item.name
          item.value = item.id
        })

        resolve(result)
      }, error => {
        reject(error)
      })
    })
  },

  uploadProductsWithCsv (formData) {
    let url = store.getters.config.api_host + '/api/products/csv'

    let config = {
      headers: {
        'Content-type': 'multipart/form-data'
      }
    }

    return new Promise((resolve, reject) => {
      store.getters.axios.post(url, formData, config).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },

  loadNotAssociatedVendorsServices () {
    return new Promise((resolve, reject) => {
      let services = CrudAPI.dfsResourceIndex(this.resource + '/vendors/notassociated')

      services.then(result => {
        result.forEach((item, i) => {
          item.text = item.name
          item.value = item.id
        })

        resolve(result)
      }, error => {
        reject(error)
      })
    })
  },

  loadCheckList (itemId, casesId = 0) {
    return new Promise((resolve, reject) => {
      let checklist = null

      if (casesId > 0) {
        checklist = CrudAPI.dfsResourceIndex(this.resource + '/' + itemId + '/case/' + casesId + '/checklist')
      } else {
        checklist = CrudAPI.dfsResourceIndex(this.resource + '/' + itemId + '/checklist')
      }

      checklist.then(result => {
        resolve(result)
      }, error => {
        reject(error)
      })
    })
  },

  searchAvailableServicesForDate (date) {
    return new Promise((resolve, reject) => {
      let services = CrudAPI.dfsResourceIndex(this.resource + '/available/' + date)

      services.then(result => {
        resolve(result)
      }, error => {
        reject(error)
      })
    })
  },

  searchAppointmentsForDate (date) {
    return new Promise((resolve, reject) => {
      let services = CrudAPI.dfsResourceIndex(this.resource + '/appointments/' + date)

      services.then(result => {
        resolve(result)
      }, error => {
        reject(error)
      })
    })
  },

  add (payload) {
    return new Promise((resolve, reject) => {
      let result = CrudAPI.dfsResourceStore(this.resource + '/withid', payload)

      result.then(result => {
        resolve(result.data.additional_data)
      }, error => {
        reject(error)
      })
    })
  },

  delete (serviceId) {
    return new Promise((resolve, reject) => {
      let result = CrudAPI.dfsResourceDestroy(this.resource, serviceId)

      result.then(result => {
        resolve(result.data.additional_data)
      }, error => {
        reject(error)
      })
    })
  },

  edit (serviceId, description, price) {
    return new Promise((resolve, reject) => {
      let result = CrudAPI.dfsResourceUpdate(this.resource, serviceId, { description: description, price: price })

      result.then(result => {
        resolve(result.data.additional_data)
      }, error => {
        reject(error)
      })
    })
  }
}

export default servicesAPI



// WEBPACK FOOTER //
// ./src/api/resources/services.js